export default "assets/images/logo-8051e595.png";